import React from 'react'
import { useSelector } from 'react-redux'

import { selectCloningStep } from '../../reducers/cloning_steps'
import { selectIsRoundsAndSeriesSelected } from '../../reducers/leagues_configs'
import { CloningStepsEnum } from '../../constants'

const StepIndicator = () => {
  const cloningStep = useSelector(selectCloningStep)
  const roundsAndSeriesSelected = useSelector(selectIsRoundsAndSeriesSelected)
  const totalSteps = roundsAndSeriesSelected ? Object.keys(CloningStepsEnum).length : Object.keys(CloningStepsEnum).length - 1

  return <span className={'cls-step-indicator'}>
    {window.I18n.t(
      `clone_leagues_sessions.general.cloning_step`,
      {step: cloningStep, steps: totalSteps},
    )}
  </span>
}

export default StepIndicator
